export const filterTradeMenuByType = (data, targetType) => {
  if (data && data.items && Array.isArray(data.items)) {
    const filteredItems = data.items.filter(item => item.type === targetType);
    return filteredItems;
  } else {
    return [];
  }
}
